export function AvatarIconDefault() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <title>A v a t a r I c o n D e f a u l t</title>
      <mask
        id="mask0_1197_252"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <circle cx="24" cy="24" r="20" fill="black" />
      </mask>
      <g mask="url(#mask0_1197_252)">
        <circle cx="24" cy="24" r="24" fill="#0BB58D" />
      </g>
    </svg>
  );
}
